import { render, staticRenderFns } from "./CaseCommercialBlock.vue?vue&type=template&id=0c36bc6e"
import script from "./CaseCommercialBlock.vue?vue&type=script&lang=js"
export * from "./CaseCommercialBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports